module.exports = __webpack_public_path__ + "img/icon-fold.659bf463.svg";